// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from ProductCard.module.scss  */
.ProductCard-module-Root_1mQ {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  box-sizing: border-box;
  width: 152px;
  height: 286px; }

.ProductCard-module-Main_1pe {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between; }
  .ProductCard-module-Main_1peBottom {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: flex-end; }

.ProductCard-module-TextLink_qti {
  display: inline-block;
  overflow: hidden;
  font-family: var(--control-font-family);
  font-size: var(--product-card-font-size);
  line-height: var(--product-card-line-height);
  text-decoration: none;
  color: var(--product-card-color-text); }

.ProductCard-module-Delivery_2yO {
  margin-top: 2px; }

.ProductCard-module-Name_1Yl {
  overflow: hidden; }

.ProductCard-module-PriceCurrent_1J9 {
  margin-bottom: 8px; }

.ProductCard-module-squashed_Itc .ProductCard-module-Thumbnail_3m9 {
  height: 124px; }

.ProductCard-module-disabled_9Xr .ProductCard-module-TextLink_qti {
  user-select: none;
  pointer-events: none;
  opacity: 0.6; }

/* Variants */
.ProductCard-module-rowVariant_2p8 {
  flex-direction: row;
  width: 343px;
  height: 156px;
  padding-bottom: 8px; }
  .ProductCard-module-rowVariant_2p8 .ProductCard-module-Thumbnail_3m9 {
    flex-shrink: 0;
    width: 148px;
    height: 148px;
    margin-right: 12px;
    margin-bottom: 0; }
  .ProductCard-module-rowVariant_2p8 .ProductCard-module-Main_1pe {
    flex: 1;
    min-width: 0; }
  .ProductCard-module-rowVariant_2p8 .ProductCard-module-Price_30w {
    max-width: 152px; }
  .ProductCard-module-rowVariant_2p8 .ProductCard-module-TextLink_qti {
    font-size: var(--product-card-font-size-row);
    line-height: var(--product-card-line-height-row); }
  .ProductCard-module-rowVariant_2p8.ProductCard-module-higher_2K4 {
    height: 184px; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/ProductCard/ProductCard.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,aAAa,EAAE;;AAEjB;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,8BAA8B,EAAE;EAChC;IACE,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,yBAAyB,EAAE;;AAE/B;EACE,qBAAqB;EACrB,gBAAgB;EAChB,uCAAuC;EACvC,wCAAwC;EACxC,4CAA4C;EAC5C,qBAAqB;EACrB,qCAAqC,EAAE;;AAEzC;EACE,eAAe,EAAE;;AAEnB;EACE,gBAAgB,EAAE;;AAEpB;EACE,kBAAkB,EAAE;;AAEtB;EACE,aAAa,EAAE;;AAEjB;EACE,iBAAiB;EACjB,oBAAoB;EACpB,YAAY,EAAE;;AAEhB,aAAa;AACb;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB,EAAE;EACrB;IACE,cAAc;IACd,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,gBAAgB,EAAE;EACpB;IACE,OAAO;IACP,YAAY,EAAE;EAChB;IACE,gBAAgB,EAAE;EACpB;IACE,4CAA4C;IAC5C,gDAAgD,EAAE;EACpD;IACE,aAAa,EAAE","sourcesContent":["/*  imported from ProductCard.module.scss  */\n.ProductCard-module-Root_1mQ {\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  box-sizing: border-box;\n  width: 152px;\n  height: 286px; }\n\n.ProductCard-module-Main_1pe {\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  justify-content: space-between; }\n  .ProductCard-module-Main_1peBottom {\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    justify-content: flex-end; }\n\n.ProductCard-module-TextLink_qti {\n  display: inline-block;\n  overflow: hidden;\n  font-family: var(--control-font-family);\n  font-size: var(--product-card-font-size);\n  line-height: var(--product-card-line-height);\n  text-decoration: none;\n  color: var(--product-card-color-text); }\n\n.ProductCard-module-Delivery_2yO {\n  margin-top: 2px; }\n\n.ProductCard-module-Name_1Yl {\n  overflow: hidden; }\n\n.ProductCard-module-PriceCurrent_1J9 {\n  margin-bottom: 8px; }\n\n.ProductCard-module-squashed_Itc .ProductCard-module-Thumbnail_3m9 {\n  height: 124px; }\n\n.ProductCard-module-disabled_9Xr .ProductCard-module-TextLink_qti {\n  user-select: none;\n  pointer-events: none;\n  opacity: 0.6; }\n\n/* Variants */\n.ProductCard-module-rowVariant_2p8 {\n  flex-direction: row;\n  width: 343px;\n  height: 156px;\n  padding-bottom: 8px; }\n  .ProductCard-module-rowVariant_2p8 .ProductCard-module-Thumbnail_3m9 {\n    flex-shrink: 0;\n    width: 148px;\n    height: 148px;\n    margin-right: 12px;\n    margin-bottom: 0; }\n  .ProductCard-module-rowVariant_2p8 .ProductCard-module-Main_1pe {\n    flex: 1;\n    min-width: 0; }\n  .ProductCard-module-rowVariant_2p8 .ProductCard-module-Price_30w {\n    max-width: 152px; }\n  .ProductCard-module-rowVariant_2p8 .ProductCard-module-TextLink_qti {\n    font-size: var(--product-card-font-size-row);\n    line-height: var(--product-card-line-height-row); }\n  .ProductCard-module-rowVariant_2p8.ProductCard-module-higher_2K4 {\n    height: 184px; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
